export default "__VITE_ASSET__B_c$v73j__"